// function to manage the URL state when a user interacts with the filters
// @param - paramString  - a string of the search parameters as chosen by the user will be passed to the function
// expected output will be that the URL is updated when the function is called

function manageUrlState(paramString) {
  const parentUrl = window.location.href.split('?')[0];

  // clean paramString: remove any key= (with no value)
  const cleanedParams = paramString
    .split('&')
    .filter((pair) => {
      const [key, value] = pair.split('=');
      return key && value && value.trim() !== '';
    })
    .join('&');

  const fullUrl = cleanedParams ? `${parentUrl}?${cleanedParams}` : parentUrl;

  history.pushState(null, null, fullUrl);
}
export default manageUrlState;
